import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
    return (
        <div className="privacy-policy-container container">
            <h1>POLITYKA PRYWATNOŚCI</h1>
            <h2>japamietam.pl</h2>
            <p>(“Polityka”)</p>

            <p>Na stronie japamietam.pl („Strona Internetowa”) umożliwiamy Ci symboliczne upamiętnienie bliskich poprzez zapalenie cyfrowego znicza.</p>
            <p>Zależy nam, byś wiedział(a), co dzieje się z Twoimi danymi osobowymi, jak je przetwarzamy i jak dbamy o ich bezpieczeństwo.</p>
            <p>Wszystkie terminy, które piszemy wielką literą mają znaczenie nadane im w <a href="https://www.japamietam.pl/regulamin">Regulaminie</a>.</p>

            <h2>Kto przetwarza Twoje dane osobowe?</h2>
            <p>
                Administratorem Twoich danych osobowych jest Radosław Poprawa, przedsiębiorca prowadzący działalność gospodarczą pod firmą Radosław Poprawa przy ul. Chociszewskiego 6C/4, 64-100 Leszno, NIP: 8971850739, REGON: 369259670 („Administrator” lub “My”).
            </p>
            <p>
                W sprawach dotyczących danych osobowych możesz napisać na adres: <a href="mailto:kontakt.japamietam@gmail.com">kontakt.japamietam@gmail.com</a> z dopiskiem „RODO”.
            </p>
            <p>Przetwarzamy dane osób, które:</p>
            <ul>
                <li>odwiedzają Stronę Internetową i przeglądają jej zawartość,</li>
                <li>wypełniają Formularz i zapalają znicz,</li>
                <li>kontaktują się z nami (np. e-mailowo w sprawach reklamacji lub zapytań).</li>
            </ul>

            <h2>Skąd posiadamy Twoje dane?</h2>
            <p>Dane przekazujesz nam bezpośrednio — np. gdy:</p>
            <ul>
                <li>odwiedzasz Stronę Internetową i przeglądasz jej zawartość,</li>
                <li>wypełniasz Formularz i zapalasz znicz,</li>
                <li>kontaktujesz się z nami poprzez e-mail.</li>
            </ul>

            <h2>Po co przetwarzamy Twoje dane?</h2>
            <p>W zależności od tego, w jakim kontekście korzystasz ze Strony Internetowej, możemy przetwarzać Twoje dane w różnych celach:</p>

            <h3>Gdy odwiedzasz Stronę Internetową i przeglądasz jej zawartość:</h3>
            <ul>
                <li>żeby zapewnić poprawne działanie Strony Internetowej (art. 6 ust. 1 lit. f RODO);</li>
                <li>żeby analizować statystyki i ulepszać treści (art. 6 ust. 1 lit. f RODO).</li>
            </ul>
            <p>Bez Twoich danych Strona Internetowa mogłaby nie działać tak, jak powinna.</p>

            <h3>Gdy wypełniasz Formularz i zapalasz znicz:</h3>
            <ul>
                <li>żeby zawrzeć z Tobą Umowę (art. 6 ust. 1 lit. b RODO);</li>
                <li>w celach podatkowych i księgowych (art. 6 ust. 1 lit. c RODO w zw. z właściwymi przepisami podatkowymi oraz księgowymi).</li>
            </ul>
            <p>Twoje dane są niezbędne do upamiętnienia Twoich bliskich za pomocą cyfrowego znicza.</p>

            <h3>Gdy kontaktujesz się z nami poprzez e-mail:</h3>
            <ul>
                <li>żeby odpowiedzieć na Twoje pytania lub reklamacje (art. 6 ust. 1 lit. f RODO).</li>
            </ul>
            <p>Bez Twoich danych nie moglibyśmy się z Tobą skontaktować i Ci pomóc.</p>

            <h2>Jakie dane możemy przetwarzać?</h2>
            <p>Kategorie danych, które przetwarzamy, zależą od tego, w jakim kontekście się spotykamy.</p>

            <h3>Gdy odwiedzasz Stronę Internetową i przeglądasz jej zawartość:</h3>
            <ul>
                <li>adres IP.</li>
            </ul>

            <h3>Gdy wypełniasz Formularz i zapalasz znicz:</h3>
            <ul>
                <li>treść wpisaną w Formularzu, numer wzoru znicza, przypisany identyfikator, status transakcji, adres IP Użytkownika oraz techniczne dane płatności (status, linki transakcyjne).</li>
            </ul>

            <h3>Gdy kontaktujesz się z nami poprzez e-mail:</h3>
            <ul>
                <li>Twój adres e-mail, a także wszystkie informacje, które dobrowolnie mi przekażesz.</li>
            </ul>

            <h2>Jak długo przechowujemy Twoje dane?</h2>
            <p>Twoje dane są u nas tylko tak długo, jak jest to naprawdę potrzebne - zgodnie z celem ich przetwarzania i przepisami prawa.</p>

            <h3>Gdy odwiedzasz Stronę Internetową i przeglądasz jej zawartość:</h3>
            <ul>
                <li>Twój adres IP – przez maksymalnie 30 dni, zgodnie z ustawieniami logów serwera.</li>
            </ul>

            <h3>Gdy wypełniasz Formularz i zapalasz znicz:</h3>
            <ul>
                <li>dane dotyczące Twojego znicza (treść, rodzaj znicza, ID, status transakcji, adres IP) przechowujemy przez rok - licząc od dokonania płatności,</li>
                <li>dane dotyczące płatności przechowujemy zgodnie z przepisami podatkowymi lub terminami przedawnienia roszczeń.</li>
            </ul>

            <h3>Gdy kontaktujesz się z nami poprzez e-mail:</h3>
            <ul>
                <li>dane z wiadomości (mail, telefon, Formularz) przechowujemy do momentu załatwienia sprawy albo przez okres wymagany przez prawo – np. ze względu na terminy przedawnienia roszczeń.</li>
            </ul>

            <h2>Komu możemy przekazać Twoje dane?</h2>
            <p>Twoje dane mogą trafić do zaufanych usługodawców, z którymi współpracujemy.</p>
            <p>W szczególności dane mogą zostać ujawnione:</p>
            <ul>
                <li>dostawcom, które wspierają nas technicznie (np. hosting, systemy IT),</li>
                <li>operatorom poczty e-mail, z których korzystamy na co dzień,</li>
                <li>doradcom i konsultantom (np. prawnym), jeśli ich pomoc dotyczy Twojej sprawy,</li>
                <li>podmiotom księgowym, które obsługują moją działalność.</li>
            </ul>
            <p>W płatnościach korzystamy z bramki płatniczej Przelewy24. Informacje na temat przetwarzanych przez PayPo S.A. danych osobowych znajdziesz tutaj.</p>


            <h2>Jakie przysługują Ci prawa w związku z przetwarzaniem danych osobowych?</h2>
            <p>Masz pełne prawo wiedzieć, co dzieje się z Twoimi danymi. W każdej chwili możesz się do nas zgłosić, żeby:</p>
            <ul>
                <li>sprawdzić, jakie dane o Tobie przetwarzamy,</li>
                <li>poprawić je, jeśli są nieaktualne lub niepełne,</li>
                <li>poprosić o ich usunięcie lub ograniczenie przetwarzania,</li>
                <li>sprzeciwić się, jeśli przetwarzamy dane na podstawie uzasadnionego interesu (art. 6 ust. 1 lit. f RODO).</li>
            </ul>
            <p>Jeśli uznasz, że Twoje dane są przetwarzane niezgodnie z przepisami – możesz też złożyć skargę do Prezesa Urzędu Ochrony Danych Osobowych.</p>
            <p>Masz pytania? Napisz na: <a href="mailto:kontakt.japamietam@gmail.com">kontakt.japamietam@gmail.com</a> z dopiskiem “RODO”.</p>

            <h2>Zmiany w Polityce prywatności</h2>
            <p>Staramy się wciąż ulepszać nasze usługi, a także dbać z najwyższą starannością o dane osobowe naszych Użytkowników. Z tego powodu treść tej Polityki może się zmieniać.</p>
            <p>Aktualna wersja będzie dostępna na tej stronie, wraz z datą jej obowiązywania.</p>
            <p>Ta wersja Polityki obowiązuje od: 01.11.2025.</p>
            <div className="back-link-container">
                <Link to="/" className="btn">Powrót do strony głównej</Link>
            </div>
        </div>
    );
}

export default PrivacyPolicy;